// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"76bf23f7","455":"d152f63c","880":"47ffb868","977":"fbc33cd4"}[chunkId] + ".chunk.js";
};